import { List, ListItem, ListSubSection } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function DemotePromoteUserGroupsList({ memberSummariesToDemote, memberSummariesToPromote }) {
  const { t } = useTranslation()
  const hasMemberSummariesToDemote = memberSummariesToDemote.length > 0
  const hasMemberSummariesToPromote = memberSummariesToPromote.length > 0
  const useListSubSection = hasMemberSummariesToDemote && hasMemberSummariesToPromote
  return (
    <List>
      {useListSubSection && (
        <ListSubSection heading={t('action.demote', 'Demote')}>
          {memberSummariesToDemote.map((memberSummary) => (
            <ListItem
              key={memberSummary.id}
              primaryText={memberSummary.name}
              endElement={<ListItem.MetaText text={memberSummary.id} />}
            />
          ))}
        </ListSubSection>
      )}
      {hasMemberSummariesToDemote && !useListSubSection && (
        <>
          {memberSummariesToDemote.map((memberSummary) => (
            <ListItem
              key={memberSummary.id}
              primaryText={memberSummary.name}
              endElement={<ListItem.MetaText text={memberSummary.id} />}
            />
          ))}
        </>
      )}
      {useListSubSection && (
        <ListSubSection heading={t('action.promote', 'Promote')}>
          {memberSummariesToPromote.map((memberSummary) => (
            <ListItem
              key={memberSummary.id}
              primaryText={memberSummary.name}
              endElement={<ListItem.MetaText text={memberSummary.id} />}
            />
          ))}
        </ListSubSection>
      )}
      {hasMemberSummariesToPromote && !useListSubSection && (
        <>
          {memberSummariesToPromote.map((memberSummary) => (
            <ListItem
              key={memberSummary.id}
              primaryText={memberSummary.name}
              endElement={<ListItem.MetaText text={memberSummary.id} />}
            />
          ))}
        </>
      )}
    </List>
  )
}
